module.exports = __webpack_public_path__ + "static/img/topImg1.743ded2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/topImg1.png
// module id = ZSts
// module chunks = 0